import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import {
  APP_UPDATE_CONFIG_ANDROID_PATH,
  APP_UPDATE_CONFIG_IOS_PATH,
} from "utils/constants/paths";

const AppUpdateConfig = Loadable(React.lazy(() => import("./View")));

export const AppUpdateConfigRoute: IRouteItem = {
  path: "/config/application-config",
  iconName: "Mobile",
  element: "",
  name: "App Update",
  accessKeys: ["ContentCreator"],
  children: [
    {
      path: APP_UPDATE_CONFIG_ANDROID_PATH,
      iconName: "Android",
      element: React.createElement(AppUpdateConfig),
      name: "Android",
    },
    {
      path: APP_UPDATE_CONFIG_IOS_PATH,
      iconName: "Apple",
      element: React.createElement(AppUpdateConfig),
      name: "IOS",
    },
  ],
};
